
export { isRegionCodeMatchStoreCode } from "/opt/atlassian/pipelines/agent/build/packages/modules/module-core/src/static/index.ts"